/**
 * Determine if a grade is in the preparatory stage (grades 3-5)
 * @param {number|string} grade - The grade level
 * @returns {boolean} - True if preparatory stage, false otherwise
 */
export const isPreparatoryGrade = (grade) => {
    // Convert grade to a number if it's a string
    const gradeNum = typeof grade === 'string' ? parseInt(grade, 10) : grade;

    // Preparatory stage is grades 3-5
    return gradeNum >= 3 && gradeNum <= 5;
};

/**
 * Determine if a grade is in the middle stage (grades 6-8)
 * @param {number|string} grade - The grade level
 * @returns {boolean} - True if middle stage, false otherwise
 */
export const isMiddleGrade = (grade) => {
    // Convert grade to a number if it's a string
    const gradeNum = typeof grade === 'string' ? parseInt(grade, 10) : grade;

    // Middle stage is grades 6-8
    return gradeNum >= 6 && gradeNum <= 8;
};

/**
 * Get the appropriate API service based on grade level
 * @param {number|string} grade - The grade level
 * @returns {Object} - The appropriate API service for the grade
 */
export const getApiServiceForGrade = (grade) => {
    // Import services directly to avoid circular dependencies
    const apiService = require('../api/apiService').default;
    const preparatoryApiService = require('../api/preparatoryApiService').default;
    const middleApiService = require('../api/middleApiService').default;

    // Convert grade to a number if it's a string
    const gradeNum = typeof grade === 'string' ? parseInt(grade, 10) : grade;

    if (isMiddleGrade(gradeNum)) {
        return middleApiService;
    } else if (isPreparatoryGrade(gradeNum)) {
        return preparatoryApiService;
    } else {
        return apiService;
    }
};